import { useMemo } from 'react';
import { ICommerceVariant } from '~/types/ICommerceVariant';

type Props = {
  variant: ICommerceVariant;
};

export function useCommerceProductSchema({ variant }: Props) {
  const numericalitySchema = useMemo(() => {
    const minimum = variant?.price.minimum || 1;

    return {
      greaterThan: minimum ? minimum - 1 : 0,
      lessThanOrEqualTo: 999999,
      message: `^Minsta gåvobelopp är ${minimum} kr`
    };
  }, [variant?.price.minimum]);

  return useMemo(
    () => ({
      price: {
        presence: {
          allowEmpty: false,
          message: '^Ange ett belopp'
        },
        numericality: numericalitySchema
      },
      quantity: {
        numericality: {
          greaterThan: 0,
          message: `^Minsta kvantitet är 1`
        }
      },
      period: {
        presence: {
          allowEmpty: false,
          message: '^Interval måste vara satt'
        }
      },
      stockStatus: {
        inclusion: ['InStock', 'FewInStock', undefined]
      }
    }),
    [numericalitySchema]
  );
}
